var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderCalendarNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "279 14 22 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M295.07,16.15v3.15c0,.32.26.61.58.61.35,0,.61-.29.61-.61v-3.15c0-.35-.26-.61-.61-.61-.32,0-.58.26-.58.61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M283.75,16.15v3.15c0,.32.29.61.61.61s.61-.29.61-.61v-3.15c0-.35-.29-.61-.61-.61s-.61.26-.61.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M299.68,16.97h-2.83v2.33c0,.09,0,.2-.03.29.12.41,0,.85-.32,1.17-.47.47-1.23.47-1.69,0-.32-.32-.41-.76-.32-1.17-.03-.09-.03-.2-.03-.29v-2.33h-8.9v2.33c0,.09,0,.2-.03.29.09.41,0,.85-.32,1.17-.47.47-1.23.47-1.69,0-.32-.32-.44-.76-.32-1.17-.03-.09-.03-.2-.03-.29v-2.33h-2.83c-.35,0-.61.26-.61.61v19.34c0,.35.26.61.61.61h19.34c.35,0,.61-.26.61-.61v-19.34c0-.35-.26-.61-.61-.61ZM298.6,35.18c0,.35-.26.61-.61.61h-15.96c-.35,0-.61-.26-.61-.61v-12.49c0-.32.26-.58.61-.58h15.96c.35,0,.61.26.61.58v12.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderCalendarNav);
export default __webpack_public_path__ + "static/media/header-calendar-nav.fc8b688d281b6c0f4e18f6cc86c97eb2.svg";
export { ForwardRef as ReactComponent };